export enum VerificationChannel {
	SMS = 'sms',
	WhatsApp = 'whatsapp',
}
